<template>
  <div class="dashboard">
    <component-navbar />
    <div class="jumbotron">
      <div class="container">
        <h1 class="display-4">
          Hello, {{ this.$store.state.user_data.name }}!
        </h1>
        <p>AKTUELL: {{ this.$store.state.current_project_id }}</p>
        <a href="javascript:void(null);" class="btn btn-info" @click="addProject()">Neues Projekt anlegen</a>


        <p class="lead">
          We hope you liked this tutorial and can now start building new astounding projects from this start point. If you're interested in what we're doing besides tech tutorials check out <a href="https://www.storyblok.com">@storyblok</a>.
        </p>
      </div>
    </div>
  </div>
</template>

<script>

import componentNavbar from '@/components/Navbar'

export default {
  components: {
    componentNavbar
  },
  data () {
    return {
    }
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    setCurrentProject( id ){
      this.$store.commit('SET_CURRENT_PROJECT', id)
    }
  }
}
</script>
